import { render } from "./LightboxAddSize.vue?vue&type=template&id=2129b3ec"
import script from "./LightboxAddSize.vue?vue&type=script&lang=js"
export * from "./LightboxAddSize.vue?vue&type=script&lang=js"

import "./LightboxAddSize.vue?vue&type=style&index=0&id=2129b3ec&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__